export default __webpack_public_path__ + "static/media/frame_bottom.556d8d88.png";